"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetTransport = resetTransport;
exports.setUpTransport = setUpTransport;
exports.transport = transport;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _constants = require("./constants");

var _firebase = require("./endPoints/firebase");

var _prometheus = require("./endPoints/prometheus");

var _logger = _interopRequireDefault(require("./logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var SEND_DELAY_MS = 5 * 1000;
var MAX_EVENTS = 50;
var DEFAULT_REMAINING_RETRIES = 5;
var isTransportReady = false;
var remainingTries = DEFAULT_REMAINING_RETRIES; // 上报数据队列

var queue = [];
var endPointQueue = {};

function processQueue(delay) {
  setTimeout(function () {
    if (remainingTries === 0) {
      return;
    }

    if (!queue.length) {
      return processQueue(SEND_DELAY_MS);
    }

    dispatchQueueEvents();
  }, delay);
}

function dispatchQueueEvents() {
  var staged = queue.slice(0, MAX_EVENTS);
  queue = queue.slice(MAX_EVENTS);
  sendToEndPoints(staged);
}

function addToQueue(data) {
  queue = [].concat(_toConsumableArray(queue), [data]);
}

function resetTransport() {
  isTransportReady = false;
  queue = [];
}

function setUpTransport() {
  if (!isTransportReady) {
    isTransportReady = true;
    processQueue(SEND_DELAY_MS);
  }
}

function sendToEndPoints(staged) {
  var promDatas = staged.filter(function (data) {
    return data.endPoints && data.endPoints.includes(_constants.PROMETHEUS_ENDPOINT_NAME);
  });

  if (promDatas.length) {
    // 这里只有单个 endpoint，所以直接在 then, catch 内处理了重试等逻辑
    // 如果是多个，可能需要在每个 handleEvents 内标记数据在某个 endpoint 内成功和失败，进而更新 staged 数据
    // 再放入 queue 中。因此这里处理 staged 的逻辑就会需要加上上一次数据在某个 endpoint 上报结果的处理。
    (0, _prometheus.handleEvents)(promDatas).then(function () {
      remainingTries = DEFAULT_REMAINING_RETRIES;
      processQueue(SEND_DELAY_MS);
    }).catch(function () {
      // 上报失败，将此次数据放入队列，下次继续处理
      remainingTries--;

      _logger.default.info("\u4E0A\u62A5\u6027\u80FD\u6570\u636E\u5269\u4F59\u91CD\u8BD5\u6B21\u6570\uFF1A".concat(remainingTries));

      queue = [].concat(_toConsumableArray(staged), _toConsumableArray(queue));
      processQueue(SEND_DELAY_MS);
    });
  }
}
/**
 * 
 * @param {Event} event
 */


function transport(event) {
  // firebase 不延时上报，其 sdk 已实现此功能
  if (event.endPoints.includes(_constants.FIREBASE_ENDPOINT_NAME)) {
    (0, _firebase.handleEvents)([_objectSpread({}, event)]);
    event.endPoints = event.endPoints.filter(function (endPoint) {
      return endPoint !== _constants.FIREBASE_ENDPOINT_NAME;
    });
  }

  addToQueue(event);
  return true;
}